import React from 'react';
import PropTypes from 'prop-types';

const BulkCheckboxHeaderCell = ({ selectionMode, promptSelectAll, togglePageTracked }) => (
  <input
    className='contact-list-react-header-checkbox'
    type='checkbox'
    checked={selectionMode === 'all' || promptSelectAll === true}
    onChange={togglePageTracked}
  />
);

BulkCheckboxHeaderCell.propTypes = {
  /** From useBulkActions - 'all, select, exclude' */
  selectionMode: PropTypes.string.isRequired,

  /** From useBulkActions - whether all on the current page are selected */
  promptSelectAll: PropTypes.bool,

  /** From useBulkActions - what happens when toggling this checkbox */
  togglePageTracked: PropTypes.func.isRequired
};

BulkCheckboxHeaderCell.defaultProps = {
  promptSelectAll: false
};

export default BulkCheckboxHeaderCell;
